import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export const useBirthProfiles = ({ allowGeneral = false } = {}) => {
  const [profiles, setProfiles] = useState([]);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    api('/profiles', { signal: controller.signal }).then(data => {
      const list = Array.isArray(data) ? data : data.profiles || [];
      setProfiles(list);
      const saved = localStorage.getItem('active_birth_profile');
      setProfileId(allowGeneral && saved === '' ? '' : list.find(p => p.profile_id === saved)?.profile_id || list.find(p => p.relationship === 'self')?.profile_id || list[0]?.profile_id || '');
    }).catch(e => { if (e.name !== 'AbortError') setError(e.message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [allowGeneral]);
  const selectProfile = id => { setProfileId(id); localStorage.setItem('active_birth_profile', id); };
  return { profiles, profileId, selectProfile, loading, error, profile: profiles.find(p => p.profile_id === profileId) };
};